import { h } from 'preact';
import { Divider } from '../Divider';
import type { ComponentShowcase } from '../registry';
import { T } from '../../../styles/tokens';

export const showcase: ComponentShowcase = {
  name: 'Divider',
  category: '📐 Layout',
  description: 'Divisor horizontal simples ou com label central',
  usedIn: ['Profile', 'AgentesPage', 'Integrations'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 8 }}>Horizontal simples:</div>
        <Divider />
      </div>
      <div>
        <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 8 }}>Com label:</div>
        <Divider label="ou" />
      </div>
    </div>
  ),
};
